
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/harmony",
      function () {
        return require("private-next-pages/harmony.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/harmony"])
      });
    }
  